import { queryOptions } from '@tanstack/react-query';
import type {
  ValidateInviteData,
  ValidateInviteResponse,
} from 'generated/openapi';

import { PublicApi } from '@/shared/api/httpClient';
import type { ReplacePathParams } from '@/shared/utils/pathParams';

export interface ValidateInviteParams {
  token: string;
}

export const validateInviteKey = (params: ValidateInviteParams) =>
  ['invites', 'validate', params.token] as const;

const validateInviteUrl = (
  token: string,
): ReplacePathParams<ValidateInviteData['url']> => `invites/${token}/validate`;

const validateInviteFn = (
  params: ValidateInviteParams,
): Promise<ValidateInviteResponse> => {
  const { token } = params;
  return PublicApi.get(validateInviteUrl(token)).json<ValidateInviteResponse>();
};

export const validateInviteOptions = <T = ValidateInviteResponse>(
  params: ValidateInviteParams,
) => {
  return queryOptions<ValidateInviteResponse, unknown, T>({
    queryKey: validateInviteKey(params),
    queryFn: () => validateInviteFn(params),
  });
};
